var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loaded)?_vm._t("default"):_c('header',{staticClass:"layout-header"},[_c('desktop-navigation'),_c('mobile-navigation')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }